import { render, staticRenderFns } from "./Mybonehealth.vue?vue&type=template&id=e2e1634e&scoped=true&"
import script from "./Mybonehealth.vue?vue&type=script&lang=js&"
export * from "./Mybonehealth.vue?vue&type=script&lang=js&"
import style0 from "./Mybonehealth.vue?vue&type=style&index=0&id=e2e1634e&scoped=true&lang=css&"
import style1 from "./Mybonehealth.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e1634e",
  null
  
)

export default component.exports